module.exports = __webpack_public_path__ + "img/1437922006.715353ff.jpg";